// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.algorithms_wrapper__3Iglh {
  min-width: calc(100% - 380px);
  width: calc(100% - 360px);
  padding: 0 12px 0 0;
  border-right: 1px solid #e0e0e0;
  overflow: auto; }

.algorithms_algorithms_title__kNzaf {
  font-weight: 600;
  font-size: 24px;
  line-height: 150%;
  margin-bottom: 20px;
  width: 100%;
  background: #f3f4f6;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 7px 10px; }
  .algorithms_algorithms_title__kNzaf span {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px; }

.algorithms_algorithms_list_item__o3k4B {
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px; }
  .algorithms_algorithms_list_item_desc__LlJe0 {
    width: calc(100% - 100px);
    height: 20px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #666666;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical; }

.algorithms_algorithms_list__yoqZS .algorithms_checkbox__G-nG5 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 16px 0 16px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  min-width: 20px;
  width: 20px;
  height: 20px;
  background: white;
  border: 1.5px solid #666666;
  border-radius: 3px;
  padding: 0;
  cursor: pointer; }
  .algorithms_algorithms_list__yoqZS .algorithms_checkbox__G-nG5:before {
    content: '';
    color: white;
    font-weight: bold;
    display: flex;
    width: 13px;
    height: 6px;
    margin-bottom: 5px;
    border-right: 1.5px solid white;
    border-top: 1.5px solid white;
    transform: rotate(135deg); }
  .algorithms_algorithms_list__yoqZS .algorithms_checkbox__G-nG5:checked {
    background: #fe6100;
    border: 1.5px solid #fe6100; }

.algorithms_algorithms_container__bE94X {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 20px 0;
  border-bottom: 1px solid #e0e0e0; }
  .algorithms_algorithms_container__bE94X h2 {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px; }
  .algorithms_algorithms_container_input__0-RqZ {
    margin-top: 10px;
    width: 350px;
    border: 1px solid #9e9e9e;
    border-radius: 4px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding: 8px 16px; }
    .algorithms_algorithms_container_input__0-RqZ:focus {
      border-color: #212121;
      outline: none; }

.algorithms_workplace__sBXPU {
  width: 100%;
  display: flex;
  gap: 5px;
  overflow: auto;
  padding: 14px 0; }
  .algorithms_workplace__sBXPU .algorithms_select__4eIpj {
    padding: 4px 12px;
    background: #fe6100;
    border-radius: 16px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1px;
    color: #ffffff;
    flex-shrink: 0;
    cursor: pointer; }
  .algorithms_workplace__sBXPU .algorithms_noSelect__Tbx8r {
    padding: 4px 12px;
    background: rgba(33, 33, 33, 0.08);
    border-radius: 16px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1px;
    color: #212121;
    flex-shrink: 0;
    cursor: pointer; }
`, "",{"version":3,"sources":["webpack://./src/pages/camera/modal/algorithms/algorithms.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc,EAAA;;AAGd;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB,EAAA;EATlB;IAWG,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;;AAInB;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAA;EACjB;IACE,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B,EAAA;;AAnBjC;EAuBG,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,eAAe,EAAA;EArClB;IAuCK,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,+BAA4C;IAC5C,6BAA0C;IAC1C,yBAAyB,EAAA;EAhD9B;IAmDK,mBAAmB;IACnB,2BAA2B,EAAA;;AAIjC;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC,EAAA;EALjC;IAOG,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EAEnB;IACE,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB,EAAA;IARlB;MAUG,qBAAqB;MACrB,aAAa,EAAA;;AAKrB;EACE,WAAW;EACX,aAAa;EACb,QAAQ;EACR,cAAc;EACd,eAAe,EAAA;EALjB;IAOI,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd,eAAe,EAAA;EAlBnB;IAqBI,iBAAiB;IACjB,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,cAAc;IACd,eAAe,EAAA","sourcesContent":[".wrapper {\n  min-width: calc(100% - 380px);\n  width: calc(100% - 360px);\n  padding: 0 12px 0 0;\n  border-right: 1px solid #e0e0e0;\n  overflow: auto;\n}\n.algorithms {\n  &_title {\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 150%;\n    margin-bottom: 20px;\n    width: 100%;\n    background: #f3f4f6;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    padding: 7px 10px;\n    span {\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 24px;\n    }\n  }\n  &_list {\n    &_item {\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      cursor: pointer;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 24px;\n      &_desc {\n        width: calc(100% - 100px);\n        height: 20px;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 24px;\n        color: #666666;\n        overflow: hidden;\n        display: -webkit-box;\n        -webkit-line-clamp: 1;\n        -webkit-box-orient: vertical;\n      }\n    }\n    .checkbox {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin: 0 16px 0 16px;\n      appearance: none;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      min-width: 20px;\n      width: 20px;\n      height: 20px;\n      background: white;\n      border: 1.5px solid #666666;\n      border-radius: 3px;\n      padding: 0;\n      cursor: pointer;\n      &:before {\n        content: '';\n        color: white;\n        font-weight: bold;\n        display: flex;\n        width: 13px;\n        height: 6px;\n        margin-bottom: 5px;\n        border-right: 1.5px solid rgb(255, 255, 255);\n        border-top: 1.5px solid rgb(255, 255, 255);\n        transform: rotate(135deg);\n      }\n      &:checked {\n        background: #fe6100;\n        border: 1.5px solid #fe6100;\n      }\n    }\n  }\n  &_container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 20px 20px 20px 0;\n    border-bottom: 1px solid #e0e0e0;\n    h2 {\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n    }\n    &_input {\n      margin-top: 10px;\n      width: 350px;\n      border: 1px solid #9e9e9e;\n      border-radius: 4px;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      padding: 8px 16px;\n      &:focus {\n        border-color: #212121;\n        outline: none;\n      }\n    }\n  }\n}\n.workplace {\n  width: 100%;\n  display: flex;\n  gap: 5px;\n  overflow: auto;\n  padding: 14px 0;\n  .select {\n    padding: 4px 12px;\n    background: #fe6100;\n    border-radius: 16px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.1px;\n    color: #ffffff;\n    flex-shrink: 0;\n    cursor: pointer;\n  }\n  .noSelect {\n    padding: 4px 12px;\n    background: rgba(33, 33, 33, 0.08);\n    border-radius: 16px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.1px;\n    color: #212121;\n    flex-shrink: 0;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `algorithms_wrapper__3Iglh`,
	"algorithms_title": `algorithms_algorithms_title__kNzaf`,
	"algorithms_list_item": `algorithms_algorithms_list_item__o3k4B`,
	"algorithms_list_item_desc": `algorithms_algorithms_list_item_desc__LlJe0`,
	"algorithms_list": `algorithms_algorithms_list__yoqZS`,
	"checkbox": `algorithms_checkbox__G-nG5`,
	"algorithms_container": `algorithms_algorithms_container__bE94X`,
	"algorithms_container_input": `algorithms_algorithms_container_input__0-RqZ`,
	"workplace": `algorithms_workplace__sBXPU`,
	"select": `algorithms_select__4eIpj`,
	"noSelect": `algorithms_noSelect__Tbx8r`
};
export default ___CSS_LOADER_EXPORT___;
